import { render, staticRenderFns } from "./RoadStatistics.vue?vue&type=template&id=12c97f2c&scoped=true&"
import script from "./RoadStatistics.vue?vue&type=script&lang=js&"
export * from "./RoadStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RoadStatistics.vue?vue&type=style&index=0&id=12c97f2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c97f2c",
  null
  
)

export default component.exports